import { render, staticRenderFns } from "./Commissions.vue?vue&type=template&id=2f506030&"
import script from "./Commissions.vue?vue&type=script&lang=ts&"
export * from "./Commissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports